import { supabase } from "../lib/supabase";
import { Agent } from "../types/booking";

/**
 * Fetch all agents
 */
export const fetchAgents = async () => {
  try {
    const { data, error } = await supabase
      .from("booking_agent")
      .select("*")
      .order("name");

    if (error) throw error;

    return { 
      data: data as Agent[], 
      error: null 
    };
  } catch (error) {
    console.error("Error fetching agents:", error);
    return { 
      data: [] as Agent[], 
      error 
    };
  }
}; 